export const stepperHorizontalData = [
    { id: 1, title: "personal", detail: "Add personal details" },
    { id: 2, title: "Address", detail: "Add additional info" },
    { id: 3, title: "Message", detail: "Add message(optional)" },
    { id: 4, title: "Done", detail: "Complete.. !" },
];